import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { userLogin as userLoginAction } from 'react-admin';

import { withStyles, createStyles } from '@material-ui/core/styles';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from '../msalAuth';

const msalInstance = new PublicClientApplication(msalConfig);
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

let callbackID = null;

const styles = ({ spacing }) =>
    createStyles({
        button: {
            width: '100%',
        },
        icon: {
            marginRight: spacing(),
        },
    });

const LoginForm = ({ classes, userLogin }) => {
    const [loading, setLoading] = useState(false);

    if (!callbackID) {
        callbackID = msalInstance.addEventCallback((event) => {
            if ((event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) && event.payload.account) {
                const account = event.payload.account;
                msalInstance.setActiveAccount(account);
                userLogin({idToken: event.payload.idToken, account: account});
            }
        });
    }

    useEffect(() => {
        //TODO: clean this up, this is not needed at all probably.
        const { searchParams } = new URL(window.location.href);
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        // If code is present, we came back from the provider
        if (code && state) {
            setLoading(true);
            userLogin({ code, state });
        }
    }, [userLogin]);

    const handleLogin = () => {
        setLoading(true);
        msalInstance.loginPopup();
        userLogin(); // Do not provide code, just trigger the redirection
    };

    return (
        <div>
            <CardActions>
                <Button
                    className={classes.button}
                    variant="contained"
                    type="submit"
                    color="primary"
                    onClick={handleLogin}
                    disabled={loading}
                >
                    {loading && (
                        <CircularProgress
                            className={classes.icon}
                            size={18}
                            thickness={2}
                        />
                    )}
                    Login with Azure AD
                </Button>
            </CardActions>
        </div>
    );
}

const mapDispatchToProps = {
    userLogin: userLoginAction,
}

export default connect(undefined, mapDispatchToProps)(withStyles(styles)(LoginForm));